import { useEffect, useState } from 'react'

const useEnableDocumentPrinting = (instanceId?: string): boolean => {
  const [current, setCurrent] = useState<boolean>(false)

  const handleChange = (e: CustomEvent): void => {
    if (instanceId) {
      e.detail.instanceId === instanceId && setCurrent(e.detail.value)
    } else {
      setCurrent(e.detail.value)
    }
  }

  useEffect(() => {
    document.addEventListener('retorik_enableDocumentPrinting', (e) => handleChange(e))
    // Dispatch event on mount to get the updated value in stead of the default one
    document.dispatchEvent(new Event('retorik_call_enableDocumentPrinting'))

    return () => {
      document.removeEventListener('retorik_enableDocumentPrinting', (e) => handleChange(e))
    }
  }, [])

  return current
}

export default useEnableDocumentPrinting
